import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";
import "firebase/messaging";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGEING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

firebase.initializeApp(config);

export default firebase;

/**
|--------------------------------------------------
| FIREBASE MESSAGING
|--------------------------------------------------
*/
var messaging = {};
try {
  messaging = firebase.messaging();
  messaging.usePublicVapidKey(
    process.env.REACT_APP_FIREBASE_MESSAGING_KEY_PAIR
  );

  Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      //
    } else {
      console.log("Unable to get permission to notify.");
    }
  });
} catch (err) {
  console.log(err);
}

export const firebaseMessaging = messaging;
